/**
 * @description CUSTOM_FEATURE_FIRM_DOMAIN_CONFIG: a list of customizations with the applicable firms' email domain.
 */

export const CUSTOM_FEATURE_FIRM_DOMAIN_CONFIG = {
	'HIDE_PROPOSAL_REPORT_BUTTON': ['edwardjones', 'ampf', 'morganstanley', 'ms', 'morganstanleypwm', 'msgraystone'],
	'HIDE_CLIENT_REPORT_BUTTON': ['edwardjones', 'ampf', 'morganstanley', 'ms', 'morganstanleypwm', 'msgraystone'],
	'KEEP_FIRM_NAME_BLANK': ['ampf']
};

export enum EmailDomainCustomizationFlags {
	HIDE_PROPOSAL_REPORT_BUTTON = 'HIDE_PROPOSAL_REPORT_BUTTON',
	HIDE_CLIENT_REPORT_BUTTON = 'HIDE_CLIENT_REPORT_BUTTON',
	KEEP_FIRM_NAME_BLANK = 'KEEP_FIRM_NAME_BLANK'
}
